/** The Site Register's side of the header bridge. The tab owns the day, the
 *  register and the export; it publishes this state so the global header can
 *  draw the title, the day controls, Refresh and Export CSV, and the header's
 *  pills fire the events below back at the tab. */

export interface SiteRegisterHeaderState {
  /** The London calendar day on screen, YYYY-MM-DD. */
  dayKey: string;
  /** Today's London date: the last day the picker offers. */
  todayKey: string;
  /** "Today", "Yesterday" or "Fri 2 Oct". */
  dayLabel: string;
  isToday: boolean;
  /** When the register on screen was read, "04:21" UK time. The page shows
   *  it beside "On site now"; the header puts it in Refresh's label. */
  updatedAt: string | null;
  refreshing: boolean;
  canRefresh: boolean;
  canExport: boolean;
}

export const SITE_REGISTER_STATE_EVENT = 'site-register:state-change';
/** Asks a mounted tab to publish again, for a header that mounts after it. */
export const SITE_REGISTER_REQUEST_STATE_EVENT = 'site-register:request-state';
/** detail: { dayKey: string | null }, where null means today. */
export const SITE_REGISTER_SET_DAY_EVENT = 'site-register:set-day';
/** detail: { days: number }. Relative, so two quick taps move two days. */
export const SITE_REGISTER_SHIFT_DAY_EVENT = 'site-register:shift-day';
export const SITE_REGISTER_REFRESH_EVENT = 'site-register:refresh';
export const SITE_REGISTER_EXPORT_EVENT = 'site-register:export';

export function requestSiteRegisterDay(dayKey: string | null): void {
  window.dispatchEvent(new CustomEvent(SITE_REGISTER_SET_DAY_EVENT, { detail: { dayKey } }));
}

export function shiftSiteRegisterDay(days: number): void {
  window.dispatchEvent(new CustomEvent(SITE_REGISTER_SHIFT_DAY_EVENT, { detail: { days } }));
}
